// src/store/testimonialDeleteSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Swal from 'sweetalert2';


export const deleteTestimonial = createAsyncThunk(
  'testimonials/deleteTestimonial',
  async (id, { rejectWithValue }) => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    if (role !== 'superadmin') {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'Only Superadmin can accept appointments',
      });
      return rejectWithValue('Unauthorized');
    }

    try {
      const response = await axios.delete(
        `https://api.thevisaman.in/api/testimonials/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire({
        icon: 'success',
        title: 'Deleted',
        text: response.data.message,
      });

      return response.data.data; 
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Delete failed',
      });
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const testimonialDeleteSlice = createSlice({
  name: 'testimonialDelete',
  initialState: {
    deletedTestimonial: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearDeleteState: (state) => {
      state.deletedTestimonial = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.deletedTestimonial = action.payload;
      })
      .addCase(deleteTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDeleteState } = testimonialDeleteSlice.actions;
export default testimonialDeleteSlice.reducer;
